import React, { useState, useEffect } from 'react';
import '../Screen.css';
import KeyboardShortcut from '../KeyboardShortcut';
import RichText from '../RichText';

function InputScreen({ block, variables = {}, onNext }) {
  const [inputValue, setInputValue] = useState('');
  const buttons = block.buttons || [];
  const button = buttons[0]; // первая кнопка — основная (submit, требует ввода)
  const extraButtons = buttons.slice(1); // доп. кнопки — альтернативные ветки (без сохранения ответа)
  const isOptionsField = block && block.variable === 'options';

  // Сбрасываем поле ввода при изменении блока
  useEffect(() => {
    setInputValue('');
  }, [block.id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputValue.trim() && button && button.nextId) {
      onNext(inputValue.trim(), button.nextId, false);
    }
  };

  const handleSkip = () => {
    if (button && button.nextId) {
      onNext(null, button.nextId, true);
    }
  };

  // Доп. кнопка: переход на свою ветку без сохранения введённого ответа.
  const handleExtra = (btn) => {
    if (btn && btn.nextId) {
      onNext(null, btn.nextId, true);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation(); // Предотвращаем всплытие события, чтобы оно не обработалось в других компонентах
      if (inputValue.trim() && button && button.nextId) {
        onNext(inputValue.trim(), button.nextId, false);
      }
    }
  };

  return (
    <div className="screen">
      <div className="screen-content">
        <h1 className="large-text">
          <RichText text={block.text} variables={variables} />
        </h1>
        <form onSubmit={handleSubmit} className="input-form">
          <textarea
            className="text-input"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Введите ответ..."
            rows="4"
          />
          <div className="button-wrapper">
            <button
              type="submit"
              className="button"
              disabled={!inputValue.trim()}
            >
              <span className="button-text">{button ? button.text : 'Далее'}</span>
              <KeyboardShortcut />
            </button>
            {isOptionsField && (
              <button
                type="button"
                className="button button-skip"
                onClick={handleSkip}
              >
                <span className="button-text">Пропустить</span>
              </button>
            )}
            {extraButtons.map((btn, i) => (
              <button
                key={i}
                type="button"
                className="button button-skip"
                onClick={() => handleExtra(btn)}
              >
                <span className="button-text">{btn.text}</span>
              </button>
            ))}
          </div>
        </form>
      </div>
    </div>
  );
}

export default InputScreen;

